import React from "react";

interface UserIconProps {
  style?: React.CSSProperties;
}
const UserIcon: React.FC<UserIconProps> = ({ style }) => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_18659_5996)">
        <path
          d="M14.9173 14.4168C17.1673 14.4168 18.9173 12.5835 18.9173 10.3335C18.9173 8.0835 17.084 6.3335 14.834 6.3335C12.584 6.3335 10.834 8.16683 10.834 10.3335C10.834 12.5835 12.6673 14.4168 14.9173 14.4168ZM14.834 8.00016C14.9173 8.00016 14.9173 8.00016 14.834 8.00016C16.1673 8.00016 17.2507 9.0835 17.2507 10.4168C17.2507 11.7502 16.1673 12.7502 14.834 12.7502C13.5007 12.7502 12.5007 11.6668 12.5007 10.4168C12.5007 9.0835 13.584 8.00016 14.834 8.00016Z"
          fill={style?.backgroundColor}
        />
        <path
          d="M27.25 13.9163C25.6667 12.4996 23.5833 11.7496 21.4167 11.8329H20.75C20.5833 12.4996 20.3333 13.0829 20 13.5829C20.5 13.4996 20.9167 13.4996 21.4167 13.4996C23 13.4163 24.5833 13.9163 25.8333 14.8329V20.8329H27.5V14.1663L27.25 13.9163Z"
          fill={style?.backgroundColor}
        />
        <path
          d="M19.5007 6.50016C19.9173 5.50016 21.084 5.00016 22.1673 5.41683C23.1673 5.8335 23.6673 7.00016 23.2507 8.0835C22.9173 8.8335 22.1673 9.3335 21.4173 9.3335C21.2507 9.3335 21.0007 9.3335 20.834 9.25016C20.9173 9.66683 20.9173 10.0835 20.9173 10.4168V10.9168C21.084 10.9168 21.2507 11.0002 21.4173 11.0002C23.5007 11.0002 25.1673 9.3335 25.1673 7.3335C25.1673 5.25016 23.5007 3.5835 21.5007 3.5835C20.1673 3.5835 19.0007 4.25016 18.334 5.41683C18.7507 5.66683 19.1673 6.00016 19.5007 6.50016Z"
          fill={style?.backgroundColor}
        />
        <path
          d="M10 13.6664C9.66667 13.1664 9.41667 12.5831 9.25 11.9164H8.58333C6.41667 11.8331 4.33333 12.5831 2.75 13.9164L2.5 14.1664V20.8331H4.16667V14.8331C5.5 13.9164 7 13.4164 8.58333 13.4998C9.08333 13.4998 9.58333 13.5831 10 13.6664Z"
          fill={style?.backgroundColor}
        />
        <path
          d="M8.58249 10.9166C8.74916 10.9166 8.91582 10.9166 9.08249 10.8333V10.3333C9.08249 9.91664 9.08249 9.49997 9.16582 9.16664C8.99916 9.24997 8.74916 9.24997 8.58249 9.24997C7.49916 9.24997 6.58249 8.3333 6.58249 7.24997C6.58249 6.16664 7.49916 5.24997 8.58249 5.24997C9.41582 5.24997 10.1658 5.74997 10.4992 6.49997C10.8325 6.0833 11.3325 5.66664 11.7492 5.3333C10.6658 3.5833 8.41582 2.99997 6.66582 4.0833C4.91582 5.16664 4.33249 7.41664 5.41582 9.16664C6.08249 10.25 7.24916 10.9166 8.58249 10.9166Z"
          fill={style?.backgroundColor}
        />
        <path
          d="M21.7507 18.9164L21.584 18.6664C19.9173 16.8331 17.584 15.7498 15.084 15.8331C12.584 15.7498 10.1673 16.8331 8.50065 18.6664L8.33398 18.9164V25.2498C8.33398 25.9998 8.91732 26.6664 9.75065 26.6664H20.4173C21.1673 26.6664 21.834 25.9998 21.834 25.2498V18.9164H21.7507ZM20.084 24.9998H10.0007V19.4998C11.334 18.1664 13.1673 17.4998 15.084 17.4998C16.9173 17.4164 18.7507 18.1664 20.084 19.4998V24.9998Z"
          fill={style?.backgroundColor}
        />
      </g>
      <defs>
        <clipPath id="clip0_18659_5996">
          <rect width="30" height="30" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export default UserIcon;
